import Swiper from 'swiper';
import getOffsetTop from '../utils/get-offset-top';

export default () => {
  const el = document.querySelector('[data-hero-swiper]');
  const video = document.querySelector('[data-bg-video]');
  const slideCount = el ? el.querySelectorAll('.swiper-wrapper > *').length : 0;
  let options;
  let swiper = {};
  const autoplay = (slideCount > 1)
    ? { delay: 5000 }
    : false;

  if (video) {
    options = {
      loop: false,
      pagination: {
        el: '[data-hero-swiper-pagination]',
        bulletClass: 'swiper-pagination-hero-bullet',
        bulletActiveClass: 'swiper-pagination-hero-bullet-active',
      },
      watchOverflow: true,
      autoplay,
    };
  } else {
    options = {
      loop: true,
      pagination: {
        el: '[data-hero-swiper-pagination]',
        clickable: true,
        bulletClass: 'swiper-pagination-hero-bullet',
        bulletActiveClass: 'swiper-pagination-hero-bullet-active',
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      watchOverflow: true,
      autoplay,
    };
  }

  if (el) {
    swiper = new Swiper(el, options);

    // resolve a chromium bug where the hero is breifly appearing in the background of the
    // page when scrolling down content as it is fixed position
    // so we have to set it to display:none once we have scrolled down past it's location
    if (el.dataset.heroSwiper === 'full-height') {
      window.addEventListener('scroll', () => {
        if (window.pageYOffset > window.innerHeight + 100) {
          el.style.display = 'none';
        } else {
          el.style.display = '';
        }
      });
    }

    // chevron scroll script
    const chevron = el.querySelector('.hero-swiper__chevron-icon');
    if (chevron) {
      window.addEventListener('load', () => {
        // const announcementHeight = document.querySelector('#shopify-section-announcement-bar')?.clientHeight || 0;
        chevron.addEventListener('click', () => {
          const pageHeader = document.querySelector('.page-header');
          const headerOffset = pageHeader
            ? getOffsetTop(pageHeader) + pageHeader.clientHeight
            : 0;
          const bannerHeight = el.clientHeight;
          const bannerTop = getOffsetTop(el);
          const offsetHeight = bannerHeight + bannerTop - headerOffset;

          window.scrollTo({
            top: offsetHeight,
            behavior: 'smooth',
          });
        });
      });
    }

    // max height adjust
    if (el.classList.contains('hero-swiper--full-height')) {
      const adjustMaxHeight = () => {
        const top = getOffsetTop(el);
        const iosViewport = document.querySelector('.ios-viewport-check');

        if (iosViewport) {
          const viewportHeight = iosViewport.clientHeight;
          const maxHeight = viewportHeight - top;
          el.style.maxHeight = `${maxHeight}px`;
          el.style.height = `${maxHeight}px`;
        } else {
          el.style.maxHeight = `calc(100vh - ${top}px)`;
          el.style.height = `calc(100vh - ${top}px)`;
        }

        el.classList.add('hero-swiper--height-adjust');
      };

      swiper.on('init', adjustMaxHeight);
      window.addEventListener('load', adjustMaxHeight);
      window.addEventListener('resize', adjustMaxHeight);
    }
  }
};
